<script setup>
import { defineModel } from 'vue';
import { useI18n } from 'vue-i18n';

defineProps({
  errors: {
    type: String,
    default: null,
    required: false,
  },
});

const { t } = useI18n();

const model = defineModel({ type: String });

const languageKeys = [
  'pt_BR',
  'pt_PT',
  'af',
  'sq',
  'ar',
  'az',
  'bn',
  'bg',
  'ca',
  'zh_CN',
  'zh_HK',
  'zh_TW',
  'hr',
  'cs',
  'da',
  'nl',
  'en',
  'en_GB',
  'en_US',
  'et',
  'fil',
  'fi',
  'fr',
  'de',
  'el',
  'gu',
  'ha',
  'he',
  'hi',
  'hu',
  'id',
  'ga',
  'it',
  'ja',
  'kn',
  'kk',
  'ko',
  'lo',
  'lv',
  'lt',
  'mk',
  'ms',
  'ml',
  'mr',
  'nb',
  'fa',
  'pl',
  'pa',
  'ro',
  'ru',
  'sr',
  'sk',
  'sl',
  'es',
  'es_AR',
  'es_ES',
  'es_MX',
  'sw',
  'sv',
  'ta',
  'te',
  'th',
  'tr',
  'uk',
  'ur',
  'uz',
  'vi',
  'zu',
];

// Map the keys to an array of objects with key and label
const languageOptions = languageKeys.map(key => ({
  key,
  label: t(`WHATSAPP_TEMPLATES.LANGUAGES.${key}`), // Use i18n to fetch the label
}));
</script>

<template>
  <label>
    {{ $t('WHATSAPP_TEMPLATES.ADD.FIELDS.LANGUAGE.LABEL') }}
    <select v-model="model" class="action__question" required>
      <option value="" disabled selected>
        {{ $t('WHATSAPP_TEMPLATES.ADD.FIELDS.LANGUAGE.PLACEHOLDER') }}
      </option>
      <option
        v-for="(lang, index) in languageOptions"
        :key="index"
        :value="lang.key"
      >
        {{ lang.label }}
      </option>
    </select>

    <p v-if="errors" class="text-red-400">
      {{ errors }}
    </p>
  </label>
</template>
